import * as React from "react";
import { BrowserRouter as Router, Routes, Route, Outlet, NavLink } from 'react-router-dom';
import '../styles/App.scss';


import Home from './Home';
import About from './About';
import Projects from './Projects';


export default function App() {
	return (
        <div className='cover'>
            <header>
                <div className='button'>
                    <button><NavLink className={({ isActive }) =>(isActive ? "active" : "normal")} to={'/'}>HOME</NavLink></button>
                    <button><NavLink className={({ isActive }) =>(isActive ? "active" : "normal")} to={'/about'}>ABOUT</NavLink></button>
                    <button><NavLink className={({ isActive }) =>(isActive ? "active" : "normal")} to={'/projects'}>PROJECTS</NavLink></button>
                </div>
            </header>

            <Routes>
                <Route path="/" element={<Home />} />
                <Route exact path={'/about'} element={<About />} />
                <Route exact path={'/projects'} element={<Projects />} />
            </Routes>
		</div>
	);
};

